// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3C8Xg","content":"LayoutSettings_content__1T2ok"};